import React from "react";
import MyContainer from "@/components/MyContainer";
import PickupAsyncTable from "@/pages/pickup/component/pickup-async-data-table";
import { LinkButton } from "@/components/ui/buttons/link-button";
import { useLocation } from "wouter";
import { routes } from "@/routes/route-constants";

export default function PickupPage() {
  const [, setLocation] = useLocation();

  const handleCreate = () => {
    setLocation(routes.pickup.new());
  };

  return (
    <MyContainer
      title="Pickups"
      enableBack={false}
      subtitle="Manage your pickup queue"
      actions={<LinkButton label="Pickup" onClick={handleCreate} />}
    >
      <PickupAsyncTable />
    </MyContainer>
  );
}
